import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import logoParking from '../../asses/img/logo-parking.png'


export default function Encabezado() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center align-items-center">
        <Col xs={12} md={10}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '30px' }}>
            <div style={{ flex: '1' }}>
              <Image
                src={logoParking}
                alt="Logo Parking"
                style={{ height: 'auto', maxWidth: '150px' }}
              />
            </div>

            <div style={{ flex: '2', textAlign: 'right' }}>
              <h4
                className="mb-0"
                style={{
                  color: '#7AC70C',
                  fontWeight: 'bold',
                  fontSize: '1.7rem',
                }}
              >
                TÉRMINOS Y CONDICIONES GENERALES
              </h4>
              <p className="mb-0 text-muted" style={{ fontSize: '0.9rem' }}>
                Versión: 01
              </p>
              <p className="mb-0 text-muted" style={{ fontSize: '0.9rem' }}>
                Fecha: 28 de agosto de 2025
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
